module.exports = __webpack_public_path__ + "66344c363821c03e32389049a0530df3.jpg";